import VertexShader from "../shaders/star/particle.vs";
import FragmentShader from "../shaders/star/particle.fs";

class ParticleMaterial extends THREE.ShaderMaterial {
    constructor({ temperature }) {
        const uniforms = {
            time: new THREE.Uniform(0),
            temperature: new THREE.Uniform(temperature),
        };

        const defines = {};

        super({
            uniforms,
            vertexShader: VertexShader,
            fragmentShader: FragmentShader,
            side: THREE.DoubleSide,
            transparent: true,
            depthWrite: false,
            blending: THREE.AdditiveBlending,
            defines
        });
    }
}

export default ParticleMaterial;
export { ParticleMaterial };